import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p397827497222209536',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
